var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input_box new-stylen-te"},[_c('vue-phone-number-input',{attrs:{"size":_vm.size,"default-country-code":_vm.country_code,"show-code-on-list":"","translations":{
      countrySelectorLabel: _vm.$t('message.country_code'),
      countrySelectorError: 'Choisir un pays',
      phoneNumberLabel: _vm.$t('message.tel_number'),
      example: _vm.$t('message.exemple'),
    }},on:{"update":_vm.getNumber},model:{value:(_vm.phone_number),callback:function ($$v) {_vm.phone_number=$$v},expression:"phone_number"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }